import React from 'react';
import { useLocation } from 'react-router-dom';
import InfoCard from './InfoCard';
import { getHelpForPath } from '../common/helpContent';

/*
 * Page-level tips, sourced from the same helpContent the Help panel reads
 * rather than restated inline. Writing them a second time per page is how the
 * two drift apart and start contradicting each other.
 *
 * Renders nothing when the route has no specific entry, so pages that fall back
 * to the generic help text do not get a card saying nothing useful.
 */
/*
 * These pages render their own info card with content more specific than the
 * help panel carries — supported audio formats, Genesys filter syntax, how the
 * search filters combine. A generic card above them would only repeat less.
 */
const HAS_OWN_CARD = [
  '/uploadRecs',
  '/search',
  '/dashboard/parsedFiles/search',
  '/fileCopy',
  '/projects',
];

const PageTips = ({ defaultOpen = false, className = '' }) => {
  const { pathname } = useLocation();

  if (HAS_OWN_CARD.includes(pathname) || pathname.startsWith('/dashboard/')) return null;

  const help = getHelpForPath(pathname);
  if (!help?.actions?.length) return null;

  return (
    <InfoCard
      id={`page-tips:${pathname}`}
      title={`${help.title} tips`}
      items={help.actions}
      defaultOpen={defaultOpen}
      className={className}
    />
  );
};

export default PageTips;
